"use client";

import React from "react";
import Link from "next/link";
import Image from "next/image";
import styles from "./WineCategoryBlocks.module.scss";

const WineCategoryBlocks = () => {
  const wineCategories = [
    {
      id: 1,
      title: "WINE BY THE GLASS",
      image:
        "/images/pages/our-steak/categories/new/wine-by-the-glass-white-wine-glass.png",
      link: "/steakhouse-menu/our-winelist/wine-by-the-glass",
    },
    {
      id: 1,
      title: "WINE MENU",
      image: "/images/pages/our-steak/categories/new/wine-menu-tnt-wines.png",
      link: "/steakhouse-menu/our-winelist/wine-menu",
    },
    {
      id: 2,
      title: "OTHER ALCOHOLIC DRINKS",
      image:
        "/images/pages/our-steak/categories/new/other-drinks-monkey-shoulder.png",
      link: "/steakhouse-menu/our-winelist/other-alcoholic-drinks",
    },
    {
      id: 3,
      title: "NON-ALCOHOLIC DRINKS",
      image:
        "/images/pages/our-steak/categories/new/non-alcoholic-drinks-cocktail.png",
      link: "/steakhouse-menu/our-winelist/non-alcoholic-drinks",
    },
  ];

  return (
    <section className={styles.menuCategorySection}>
      <div className="container">
        <div className="row g-4 justify-content-center">
          {wineCategories.map((category) => (
            <div
              key={category.id}
              className="col-lg-3 col-md-6 col-sm-6 col-12"
            >
              <Link href={category.link} className={styles.categoryLink}>
                <div className={styles.categoryBlock}>
                  <div className={styles.imageContainer}>
                    <Image
                      src={category.image}
                      alt={category.title}
                      width={300}
                      height={200}
                      className={styles.categoryImage}
                      priority={category.id <= 4} // Prioritize loading for first 4 images
                    />
                    <div className={styles.overlay}>
                      <div className={styles.categoryTitle}>
                        {category.title}
                      </div>
                    </div>
                  </div>
                </div>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WineCategoryBlocks;
